export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/product-prices`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/product-prices/${ID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/product-prices`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/product-prices/${ID}`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/product-prices/${ID}`;
}

